import { useQuery } from '@apollo/client';
import { graphql } from '@/gql/__codegen__';
import type {
  UserCreate_ValidatePasswordQuery,
  UserCreate_ValidatePasswordQueryVariables,
} from '@/gql/__codegen__/graphql';
import type { QueryHookOptions } from '@apollo/client';

const QUERY = graphql(`
  query userCreate_validatePassword($password: String!) {
    validatePassword(password: $password) {
      userErrors {
        message
        code
      }
      valid
    }
  }
`);

type HookOptions = QueryHookOptions<
  UserCreate_ValidatePasswordQuery,
  UserCreate_ValidatePasswordQueryVariables
>;

export function useValidatePasswordQuery(options?: HookOptions) {
  return useQuery(QUERY, options);
}
